export const ROUTE_DATA = {
  PRODUCT_DETAIL: 'PRODUCT_DETAIL',
  VOUCHER_DETAIL: 'VOUCHER_DETAIL',
  VOUCHER_USED_DETAIL: 'VOUCHER_USED_DETAIL',
  SURVEY_DETAIL: 'SURVEY_DETAIL',
  POLICY_DETAIL: 'POLICY_DETAIL',
};
